import React from "react";
import and from "../images/and.png";
import ios from "../images/ios.png";

export const Qrcode = () => {
  return (
    <div id="features" className="text-center">
      <div className="container">
        <div className="col-md-10 col-md-offset-1 section-title"  style={{marginTop:'80px'}}>
          <h2>Applications</h2>
        </div>

        <div className="row">
          <div className="col-sm-6 col-md-3 col-md-offset-3 text-center">
            <img
              src={and}
              alt="Android"
              className="img-responsive center-block platform-img"
              style={{ height: "200px", marginBottom: "70px" }}
            />
          </div>

          <div className="col-sm-6 col-md-3 text-center">
            <img
              src={ios}
              alt="iOS"
              className="img-responsive center-block platform-img"
              style={{ height: "200px", marginBottom: "70px" }}
            />
          </div>
        </div>
      </div>
    </div>
  );
};
